var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophoneOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#333",
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5189 12.8645C15.5189 12.4826 15.2092 12.1729 14.8271 12.1729C14.445 12.1729 14.1353 12.4826 14.1353 12.8645C14.1353 16.2483 11.3826 19.001 7.99879 19.001C4.61517 19.001 1.86248 16.2483 1.86248 12.8645C1.86248 12.4826 1.55277 12.1729 1.17068 12.1729C0.788591 12.1729 0.478882 12.4826 0.478882 12.8645C0.478882 16.778 3.48359 20.0019 7.30716 20.3523V22.2147H4.73977C4.35767 22.2147 4.04796 22.5244 4.04796 22.9065C4.04796 23.2886 4.35767 23.5983 4.73977 23.5983H11.258C11.6399 23.5983 11.9498 23.2886 11.9498 22.9065C11.9498 22.5244 11.6399 22.2147 11.258 22.2147H8.69059V20.3523C12.5142 20.0021 15.5189 16.778 15.5189 12.8645Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99888 17.294C5.55661 17.294 3.56952 15.3069 3.56952 12.8645V4.83098C3.56952 2.3887 5.55661 0.401611 7.99888 0.401611C10.4413 0.401611 12.4284 2.3887 12.4284 4.83098V12.8645C12.4284 15.3069 10.4413 17.294 7.99888 17.294Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99858 0.401611C7.9938 0.401611 7.98903 0.401788 7.98407 0.401788V17.2938C7.98903 17.2938 7.9938 17.294 7.99858 17.294C10.441 17.294 12.4281 15.3069 12.4281 12.8645V4.83098C12.4281 2.3887 10.441 0.401611 7.99858 0.401611Z",
    fill: "#000",
    fillOpacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOn);
export default __webpack_public_path__ + "static/media/microphone-on.79d9a6c5.svg";
export { ForwardRef as ReactComponent };